// TODO: move to env variable
export const BASE_URL = 'https://genbays-yt.vercel.app';
// export const BASE_URL = 'http://localhost:4000';
